import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
@Component({
  selector: 'bll-accordion-icon-arrow',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .bll-accordion-arrow-right {
        transform: rotate(-135deg);
        right: 0;
      }
      .bll-accordion-arrow-left {
        transform: rotate(135deg);
        left: 0;
      }
      :host.active .bll-accordion-arrow-right {
        transform: rotate(-45deg);
      }
      :host.active .bll-accordion-arrow-left {
        transform: rotate(45deg);
      }
    `,
  ],
  template: `<div
      class="bll-accordion-arrow-left"
      [ngClass]="classNames"
      [style.borderBottomWidth.px]="borderBottom"
      [style.height]="_size"
      [style.width.px]="thickness"
    ></div>
    <div
      class="bll-accordion-arrow-right"
      [ngClass]="classNames"
      [style.width.px]="thickness"
      [style.borderBottomWidth.px]="borderBottom"
      [style.height]="_size"
      [style.width.px]="thickness"
    ></div>
    <ng-content></ng-content>`,
  host: {
    class: 'tw-inline-block tw-relative',
    '[class.active]': 'active',
  },
})
export class BllAccorionIconArrowComponent {
  @Input() active: boolean;
  @Output() activeChange: EventEmitter<boolean> = new EventEmitter();

  @HostBinding('style.color')
  @Input()
  color = 'var(--primary)';
  @HostBinding('style.width')
  @HostBinding('style.height')
  get _size() {
    return (this.size * (2 / 3)).toString() + 'px';
  }

  get borderBottom() {
    return this.size * (2 / 3) + 4;
  }
  @Input() size: number = 16;

  @Input() thickness: number = 2;

  classNames =
    'tw-absolute tw-transform tw-transition-transform tw-bg-transparent tw-rounded-2xl tw-top-0 tw-border-current';
}
